import { cn } from '@/shared/utils/helpers/cn'
import { NavLink } from 'react-router-dom'
import { CountBadge } from '@/shared/components/Glass'

interface SidebarNavItemProps {
  to: string
  icon: React.ReactNode
  label: string
  badge?: { count: number | string; color: 'indigo' | 'green' | 'amber' | 'red' | 'blue' }
  collapsed?: boolean
}

export function SidebarNavItem({ to, icon, label, badge, collapsed }: SidebarNavItemProps) {
  return (
    <NavLink
      to={to}
      className={({ isActive }) =>
        cn(
          'flex items-center gap-2.5 px-3 py-2 rounded-lg text-sm transition-all',
          isActive
            ? 'bg-blue-500/15 text-blue-400'
            : 'text-white/50 hover:bg-white/[0.06] hover:text-white/70',
          collapsed && 'justify-center px-2',
        )
      }
    >
      <span className="text-base flex-shrink-0 w-5 h-5 flex items-center justify-center">{icon}</span>
      {!collapsed && (
        <>
          <span className="truncate">{label}</span>
          {badge && (
            <CountBadge count={badge.count} color={badge.color} className="ml-auto" />
          )}
        </>
      )}
    </NavLink>
  )
}
